import Skeleton from 'components/loading/Skeleton';
import Flex from 'components/util/Flex';

type Props = {
  isDesktop?: boolean;
};

/**
 * 수익분배약관 미동의 상태(동의 모달 노출) 또는 인증 정보 조회 중에, 실제 수익 데이터 대신 노출하는
 * 대시보드 스켈레톤. 대시보드 레이아웃(정보 행 / 차트 / 랭킹)을 경량으로 흉내낸다.
 */
export default function DashboardSkeleton({ isDesktop }: Props) {
  return (
    <Flex rowGap={8} direction="column">
      {/* 상단 정보 행 (RevenueInformation + CreatorInformation) */}
      <Flex
        columnGap={isDesktop ? 8 : 0}
        rowGap={isDesktop ? 0 : 8}
        isExpanded
        direction={isDesktop ? 'row' : 'column'}
      >
        <Flex isExpanded>
          <Skeleton height="160px" />
        </Flex>
        <Flex isExpanded>
          <Skeleton height="160px" />
        </Flex>
      </Flex>
      {/* 차트 (RevenueChart) */}
      <Skeleton height="320px" />
      {/* 랭킹 (MonthlyRevenueRanking) */}
      <Skeleton height="360px" />
    </Flex>
  );
}
